import { queryGetSignUpTerminationReport } from '../Queries';
import moment from 'moment-timezone';
import featureFlags from '../featureFlags';

const isEmpty = value => value === null || value === '' || value === undefined;

const convertLowerBoundDate = date => {
  return moment(date).tz('UTC').set('hour', 0).set('minute', 0).set('second', 0);
}

const convertUpperBoundDate = date => {
  return moment(date).tz('UTC').set('hour', 23).set('minute', 59).set('second', 59);
}

const convertToGraphQLFilters = (facilityId, filterValues) => {
  const { parkerStartDate, parkerEndDate, transactionStartDate, transactionEndDate } = filterValues;

  const parkerStatusHistoryFilter = !(isEmpty(parkerStartDate) && isEmpty(parkerEndDate)) ? {
    model: 'PARKER_STATUS_HISTORY',
    op: 'OR',
    sub_expressions: [
      {
        model: 'PARKER_STATUS_HISTORY',
        op: 'AND',
        filters: [
          {
            field: 'action',
            op: 'EQ',
            value: 'Parker Start Date'
          },
          ...(!isEmpty(parkerEndDate) ? [{
            field: 'start_date',
            op: 'LTE',
            value: convertUpperBoundDate(parkerEndDate)
          }] : []),
          ...(!isEmpty(parkerStartDate) ? [{
            field: 'start_date',
            op: 'GTE',
            value: convertLowerBoundDate(parkerStartDate)
          }] : [])
        ]
      },
      {
        model: 'PARKER_STATUS_HISTORY',
        op: 'AND',
        filters: [
          {
            field: 'action',
            op: 'EQ',
            value: 'Terminate'
          },
          ...(!isEmpty(parkerEndDate) ? [{
            field: 'start_date',
            op: 'LTE',
            value: convertUpperBoundDate(parkerEndDate)
          }] : []),
          ...(!isEmpty(parkerStartDate) ? [{
            field: 'start_date',
            op: 'GTE',
            value: convertLowerBoundDate(parkerStartDate)
          }] : [])
        ]
      }
    ]
  } : {};

  const transactionFilter = !(isEmpty(transactionStartDate) && isEmpty(transactionEndDate)) ? {
    model: 'PARKER',
    op: 'AND',
    filters: [
      ...(transactionEndDate ? [{
        field: 'created_at',
        op: 'LTE',
        value: convertUpperBoundDate(transactionEndDate)
      }] : []),
      ...(transactionStartDate ? [{
        field: 'created_at',
        op: 'GTE',
        value: convertLowerBoundDate(transactionStartDate)
      }] : [])
    ]
  } : {}

  const filterExpressions = [
    {
      model: 'BILLING_PROFILE',
      op: 'AND',
      filters: [
        {
          field: 'facility_id',
          op: 'EQ',
          value: facilityId
        }
      ]
    },
    {
      model: 'PARKER',
      op: 'AND',
      filters: [
        {
          field: 'suspension_status',
          op: 'NE',
          value: 'PENDING'
        }
      ]
    },
    {
      model: 'PARKER',
      op: 'AND',
      filters: [
        {
          field: 'termination_status',
          op: 'NE',
          value: 'PENDING'
        }
      ]
    },
    parkerStatusHistoryFilter,
    transactionFilter
  ];

  return { filter_expressions: filterExpressions };
}

export default {
  initialFilters: {
    parkerStartDate: null,
    parkerEndDate: null,
    transactionStartDate: null,
    transactionEndDate: null,
  },
  reportQuery: (facilityId, filterValues) => {
    const filters = convertToGraphQLFilters(facilityId, filterValues);
    return queryGetSignUpTerminationReport(filters);
  },
  fileName: 'signup_termination_report.csv',

}